import React, { useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import logo from "../../assets/images/logo-light1.svg"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import { useInvestorForgotPasswordMutation } from "store/api/investorapi/auth.api"
import { useWealthPartnerForgotPasswordMutation } from "store/api/wealthpartnerapi/auth/auth.api"

const AdminForgotPassword = (props) => {
  //meta title
  document.title = "Forgot password | Prachay"

  const [investorForgotPassword, { isLoading }] =
    useInvestorForgotPasswordMutation()
  const [wealthPartnerForgotPassword, { isLoading: isAuthenticating }] =
    useWealthPartnerForgotPasswordMutation()

  const [loginType, setLoginType] = useState("INVESTOR")
  const navigate = useNavigate()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  const onFormSubmit = async (params) => {
    try {
      const { success, message } =
        loginType === "INVESTOR"
          ? await investorForgotPassword(params).unwrap()
          : await wealthPartnerForgotPassword(params).unwrap()

      if (success) {
        navigate("/login")
        toast.success(message, { id: "toastMessage" })
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <div className="account-pages">
      <Row className="g-0">
        <Col md={7} lg={7} xl={7} className="p-0 m-0">
          <div className="log-in-blue-bg-cover">
            <div className="login-page-text">
              <h4>Managing your</h4>
              <h5>
                <span> CORPORATE TREASURY </span> was never so easy
              </h5>
              <p>Introducing Prachay ICDs</p>
            </div>
            <div className="login-page-bottom-text">
              <h4>DON'T LEAVE</h4>
              <h5>
                YOUR <span style={{ color: "#f0a634" }}>SURPLUS </span>{" "}
                UNMANAGED
              </h5>
            </div>
          </div>
        </Col>

        <Col md={5} lg={5} xl={5}>
          <div className="overflow-hidden login-form-wrapper px-1">
            <Card>
              <CardBody>
                <Link to="/" className="">
                  <img src={logo} alt="" height="50" />
                </Link>
                <div className="login-text mt-3">
                  <h4>Forgot your password?</h4>
                  <p>
                    Please enter your registered email address. We will send you
                    a password reset link shortly.
                  </p>
                </div>

                <div className="pt-0">
                  <div className="p-2">
                    {/* <div className="login-tab-container">
                      <div
                        className={`tab ${
                          loginType === "INVESTOR" ? "active" : ""
                        }`}
                        onClick={() => setLoginType("INVESTOR")}
                      >
                        Investor
                      </div>
                      <div
                        className={`tab ${
                          loginType === "WEALTH_PARTNER" ? "active" : ""
                        }`}
                        onClick={() => setLoginType("WEALTH_PARTNER")}
                      >
                        Wealth Partner
                      </div>
                    </div> */}
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-2">
                        <Label className="form-label">
                          Email address
                          <span className="error">*</span>
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email Address"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block position-relative"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading || isAuthenticating ? (
                            <Spinners />
                          ) : (
                            "Send Link"
                          )}
                        </button>
                      </div>

                      <div
                        className="mt-2 text-center"
                        style={{ fontSize: "15px" }}
                      >
                        Remember password?{" "}
                        <Link
                          to="/login"
                          style={{ color: "#035ca1", fontWeight: "bold" }}
                        >
                          click here
                        </Link>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default withRouter(AdminForgotPassword)
